<template>
	<div>
		<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
			 size="mini">

			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>

			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			

			<el-table-column prop="gender" label="性别" width="60" align="center">
				<template slot-scope="scope">

					<span v-if="scope.row.gender == 1">男</span>
					<span v-if="scope.row.gender == 2">女</span>

					<span v-if="scope.row.gender == 0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" width="150"></el-table-column>
			<el-table-column prop="remark" label="申请住宿" width="100">
				<template slot-scope="scope">

					是
				</template>
			</el-table-column>
			<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>
			<el-table-column prop="major_name" label="专业" min-width="140"></el-table-column>
			<el-table-column prop="xuezhi" label="班级" min-width="140"></el-table-column>
			
			<el-table-column prop="status" label="审批状态" width="80">
			

				<template slot-scope="scope">
				
					<div>
						<span v-if="scope.row.sp_status == 1" style="color: green;">已审核</span>
						<span v-if="scope.row.sp_status == 2" style="color: orangered;">审核不通过</span>
						<span v-if="!scope.row.sp_status" style="color: gray;">未审核</span>
					</div>

				</template>
			</el-table-column>
			

			<el-table-column fixed="right" label="操作" width="100">
				<template slot-scope="scope">
					
					<el-button @click="showInfo(scope.row)" type="text" size="small">审核
					</el-button>

				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>

	</div>
</template>
<script>


export default {
	name: 'Table',
	components: {

	},
	name: 'Table',
	data() {
		return {
			stuid: 0,
			showPrint: false,
			showBM: false,
			showQrb: false,
			stuinfo: null
		}
	},
	props: {
		page: {
			type: Object,
		},
		tableData: {
			type: Array,
			default: []
		},
		from: {
			type: String,
			default: ''
		},
		multSelect: {
			type: Boolean,
			default: true
		},
		pmid: {
			type: Number,
			default: 1
		}

	},
	methods: {
		handleModify(row) {
			row.showbtn = false
			row.ksxiugai = false
			this.$emit('handleModify', row)
		},
		only2word(row) {
			row.showbtn = true
			row.ksxiugai = true
			this.$emit('handleModify', row)
		},
		handleDel(row) {
			this.$emit('handleDel', row)
		},
		handleSelectionChange(val) {
			this.$emit('handleSelectionChange', val)
		},
		handlePageChange(e) {
			this.$emit('handlePageChange', e)
		},
		handleSizeChange(e) {
			this.$emit('handleSizeChange', e)
		},
		showPrintDialog(e) {
			this.stuid = e.id
			this.showPrint = true
		},
		closePrint() {
			this.showPrint = false
		},
		//BM
		showBMDialog(e) {
			this.stuid = e.id
			this.showBM = true
		},
		closeBM() {
			this.showBM = false
		},
		showQrbDialog(row) {
			this.stuinfo = row
			this.showQrb = true
		},
		showInfo(item){
			this.$$parent(this,"stuid",item.id)
			this.$$parent(this,"formshow",true)
		}
	}
}
</script>
